import { Form, Formik } from 'formik';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { PasswordField } from '../../components/PasswordField';
import { getTouchedError } from '../../utils/get-touched-error.util';
import { AlertMessages } from '../../components/AlertMessages';
import { LoginSchema } from './schemas/login.schema';
import { useInitialValuesFactory } from './hooks/useInitialValuesFactory.hook';
import { useLoginSubmit } from './hooks/useSubmit.hook';

export const LoginForm = () => {
  const { initialValues } = useInitialValuesFactory();

  const { formError, handleSubmit } = useLoginSubmit();

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={LoginSchema}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit: formikSubmit,
        isSubmitting,
        isValid,
        touched,
        values,
      }) => (
        <Form onSubmit={formikSubmit}>
          <Grid container spacing={2} sx={{ maxWidth: '480px' }}>
            <Grid size={12} sx={{ pt: 1, pb: 1, textAlign: 'center' }}>
              <Typography component="h1" variant="h4">
                Connexion
              </Typography>
            </Grid>
            <Grid size={12} sx={{ pt: 1, pb: 1 }}>
              <TextField
                autoComplete="email"
                error={!!(errors.email && touched.email)}
                fullWidth
                helperText={getTouchedError(errors, touched, 'email')}
                id="login-email"
                label="Adresse e-mail"
                name="email"
                onBlur={handleBlur}
                onChange={handleChange}
                required
                type="email"
                value={values.email}
                variant="outlined"
              />
            </Grid>
            <Grid size={12} sx={{ pt: 1, pb: 1 }}>
              <PasswordField
                autoComplete="current-password"
                error={!!(errors.password && touched.password)}
                fullWidth
                helperText={getTouchedError(errors, touched, 'password')}
                id="login-password"
                label="Mot de passe"
                name="password"
                onBlur={handleBlur}
                onChange={handleChange}
                required
                value={values.password}
                variant="outlined"
              />
            </Grid>
            {!!formError && (
              <Grid size={12} sx={{ pt: 1, pb: 1 }}>
                <AlertMessages messages={formError} severity="error" />
              </Grid>
            )}
            <Grid size={12} sx={{ pt: 1, pb: 1 }}>
              <Button
                disabled={!isValid}
                fullWidth
                id="login-submit"
                loading={isSubmitting}
                size="large"
                type="submit"
                variant="contained"
              >
                Se connecter
              </Button>
            </Grid>
            <Grid size={12} sx={{ pt: 1, pb: 1 }}>
              <Typography variant="body1">
                Veuillez vous rapprocher de votre responsable pour vos demandes
                de création de compte, de mot de passe égaré ou de problèmes de
                connexion.
              </Typography>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};
